import React from "react";
import { Form } from "react-bootstrap";

import { Field } from "../../utils/components/form";
import { InputError, Tooltip } from '.';

export const InputFieldRow = (props = {}) => {
  let { name, label, buttonLabel, placeholder, tooltip, className, imageData, imageClass, input, maxLength, children, validate, ...attributes } = props;
  const inputClass = className || "form-control form-control-lg col-12 col-lg-7";
  const inputProps = { ...input };
  return <tr className="bg-white">
    <td>
      <label className="fs-5 text-gray" htmlFor={name}>
        {label}
        <Tooltip>{tooltip}</Tooltip>
      </label>
    </td>
    <td>
      {input && input.type === "file"
        ? <>
          <div className="d-flex">
            <div className="row">
              <label className={`btn btn-default col form-control form-control-lg${inputProps.disabled ? " disabled" : ""}`}>
                {buttonLabel} ...
                <input
                  className="d-none"
                  name={name}
                  disabled={inputProps.disabled}
                  {...input}
                />
              </label>
              {children}
            </div>
          </div>
          {imageData
            ? <img className={imageClass || "small-image"} src={imageData} alt={label} />
            : null
          }
        </>
        : <Field
          name={name}
          {...input}
          validate={validate}
        >
          {({ input, meta }) => {
            return (
              <>
                <Form.Control
                  className={(inputClass ? inputClass : "") + (meta && meta.error && !meta.modified ? " is-invalid" : "")}
                  {...input}
                  {...attributes}
                  {...inputProps}
                  tabIndex="0"
                  autoComplete="off"
                  placeholder={placeholder ? `${placeholder} eingeben...` : null}
                  size="lg"
                  isInvalid={meta && meta.touched && meta.error}
                  isValid={meta && meta.touched && !meta.error}
                  maxLength={maxLength}
                />
                <InputError meta={meta} />
              </>
            );
          }}
        </Field>
      }
      {!input || input.type !== "file" ? children : null}
    </td>
  </tr>;
};
